<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 mat-dialog-title>Acción realizada :: <strong>Ver</strong></h1>
<div mat-dialog-content cdkTrapFocus>
    <app-ver-permiso></app-ver-permiso>
</div>
